export default __webpack_public_path__ + "static/media/mobile_logo.c50c3996.svg";